const ISO3_TO_ISO2_PHONE_COUNTRY_CODES = {
  ABW: "AW", AFG: "AF", AIA: "AI", ALA: "AX", ALB: "AL", DZA: "DZ", AND: "AD", AGO: "AO",
  ARG: "AR", ARM: "AM", ASM: "AS", ATG: "AG", AUS: "AU", AUT: "AT", AZE: "AZ", BHS: "BS",
  BHR: "BH", BGD: "BD", BRB: "BB", BLR: "BY", BEL: "BE", BES: "BQ", BLZ: "BZ", BEN: "BJ",
  BGR: "BG", BTN: "BT", BLM: "BL", BOL: "BO", BMU: "BM", BIH: "BA", BWA: "BW", BRA: "BR",
  BRN: "BN", BFA: "BF", BDI: "BI", CPV: "CV", KHM: "KH", CMR: "CM", CAN: "CA", CAF: "CF",
  CCK: "CC", TCD: "TD", CHL: "CL", CHN: "CN", COL: "CO", COM: "KM", COG: "CG", COD: "CD",
  CRI: "CR", CIV: "CI", COK: "CK", HRV: "HR", CUB: "CU", CUW: "CW", CXR: "CX", CYM: "KY",
  CYP: "CY", CZE: "CZ", DNK: "DK", DJI: "DJ", DMA: "DM", DOM: "DO", ECU: "EC", EGY: "EG",
  SLV: "SV", GNQ: "GQ", ERI: "ER", ESH: "EH", EST: "EE", SWZ: "SZ", ETH: "ET", FJI: "FJ",
  FIN: "FI", FRA: "FR", FLK: "FK", FRO: "FO", GAB: "GA", GMB: "GM", GEO: "GE", DEU: "DE",
  GGY: "GG", GHA: "GH", GIB: "GI", GLP: "GP", GRC: "GR", GRD: "GD", GRL: "GL", GTM: "GT",
  GIN: "GN", GNB: "GW", GUF: "GF", GUM: "GU", GUY: "GY", HTI: "HT", HND: "HN", HKG: "HK",
  HUN: "HU", ISL: "IS", IMN: "IM", IND: "IN", IDN: "ID", IOT: "IO", IRN: "IR", IRQ: "IQ",
  IRL: "IE", ISR: "IL", ITA: "IT", JAM: "JM", JEY: "JE", JPN: "JP", JOR: "JO", KAZ: "KZ",
  KEN: "KE", KIR: "KI", PRK: "KP", KOR: "KR", KWT: "KW", KGZ: "KG", LAO: "LA", LVA: "LV",
  LBN: "LB", LSO: "LS", LBR: "LR", LBY: "LY", LIE: "LI", LTU: "LT", LUX: "LU", MAC: "MO",
  MAF: "MF", MDG: "MG", MWI: "MW", MYS: "MY", MDV: "MV", MLI: "ML", MLT: "MT", MHL: "MH",
  MRT: "MR", MUS: "MU", MEX: "MX", FSM: "FM", MDA: "MD", MCO: "MC", MNG: "MN", MNE: "ME",
  MAR: "MA", MOZ: "MZ", MMR: "MM", MNP: "MP", MSR: "MS", MTQ: "MQ", MYT: "YT", NAM: "NA",
  NRU: "NR", NPL: "NP", NLD: "NL", NCL: "NC", NFK: "NF", NZL: "NZ", NIC: "NI", NER: "NE",
  NGA: "NG", NIU: "NU", MKD: "MK", NOR: "NO", OMN: "OM", PAK: "PK", PLW: "PW", PAN: "PA",
  PNG: "PG", PRY: "PY", PER: "PE", PHL: "PH", POL: "PL", PRT: "PT", PRI: "PR", PSE: "PS",
  PYF: "PF", QAT: "QA", REU: "RE", ROU: "RO", RUS: "RU", RWA: "RW", SCT: "GB", KNA: "KN",
  LCA: "LC", VCT: "VC", WSM: "WS", SMR: "SM", STP: "ST", SAU: "SA", SEN: "SN", SRB: "RS",
  SHN: "SH", SJM: "SJ", SYC: "SC", SLE: "SL", SGP: "SG", SVK: "SK", SVN: "SI", SLB: "SB",
  SOM: "SO", SPM: "PM", ZAF: "ZA", SSD: "SS", ESP: "ES", LKA: "LK", SDN: "SD", SUR: "SR",
  SWE: "SE", CHE: "CH", SXM: "SX", SYR: "SY", TCA: "TC", TWN: "TW", TJK: "TJ", TZA: "TZ",
  THA: "TH", TKL: "TK", TLS: "TL", TGO: "TG", TON: "TO", TTO: "TT", TUN: "TN", TUR: "TR",
  TKM: "TM", TUV: "TV", UGA: "UG", UKR: "UA", ARE: "AE", GBR: "GB", USA: "US", URY: "UY",
  UZB: "UZ", VGB: "VG", VIR: "VI", VUT: "VU", VAT: "VA", VEN: "VE", VNM: "VN", WLF: "WF",
  XKX: "XK", YEM: "YE", ZMB: "ZM", ZWE: "ZW",
};

const ISO2_TO_ISO3_PHONE_COUNTRY_CODES = Object.entries(ISO3_TO_ISO2_PHONE_COUNTRY_CODES).reduce(
  (accumulator, [iso3Code, iso2Code]) => {
    if (!accumulator[iso2Code]) {
      accumulator[iso2Code] = iso3Code;
    }
    return accumulator;
  },
  {}
);

export {
  ISO2_TO_ISO3_PHONE_COUNTRY_CODES,
  ISO3_TO_ISO2_PHONE_COUNTRY_CODES,
};
